import { render, staticRenderFns } from "./EditorController.vue?vue&type=template&id=e6bf63be&scoped=true&"
import script from "./EditorController.vue?vue&type=script&lang=ts&"
export * from "./EditorController.vue?vue&type=script&lang=ts&"
import style0 from "./EditorController.vue?vue&type=style&index=0&id=e6bf63be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bf63be",
  null
  
)

export default component.exports